<template>
    <div>
        <div class="table-toolbar mb-3">
            <div class="d-flex align-items-center flex-shrink-0">
                <div class="d-flex align-items-center" v-if="tblData?.download?.length > 0 && tblData.rows.length > 0">
                    <a class="me-2 btn btn-option" href="javascript:void(0)" v-for="btn in tblData?.download"
                       @click="btn.action">
                        <img v-if="!btn.loading" :class="btn.icon" width="16" height="16"/>
                        <span v-if="btn.loading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                    </a>
                </div>
                <div class="d-flex align-items-center" v-if="tblData?.checkboxOption?.length > 0">
                    <a class="me-2 btn btn-option" href="javascript:void(0)"
                       v-if="selectedData.length > 0" v-for="btn in tblData?.checkboxOption"
                       @click="btn.action(selectedData)">
                        <img :class="btn.icon" width="16" height="16"/>
                    </a>
                </div>
            </div>
            <div class="dataTables_filter d-flex align-items-center justify-content-end flex-wrap gap-2">
                <template v-if="tblData?.dateSearch">
                    <div v-if="tblData.dateSearch?.mode == 'range'" class="d-flex align-items-center flex-wrap gap-2">
                        <flat-pickr class="form-control table-control form-control-sm"
                                    v-model="startDate"
                                    placeholder="Start Date"
                                    :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"
                                    @on-change="onRangeDateChange"/>
                        <flat-pickr class="form-control table-control form-control-sm"
                                    v-model="endDate"
                                    placeholder="End Date"
                                    :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"
                                    @on-change="onRangeDateChange"/>
                    </div>
                    <div v-if="tblData.dateSearch?.mode == 'single'" class="position-relative">
                        <flat-pickr class="form-control table-control form-control-sm" v-model="date"
                                    :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}" placeholder="Select Date"
                                    @on-change="tblData?.dateSearch.action(date)"/>
                        <i class="bx bx-calendar calendar-icon table-icon"></i>
                    </div>
                </template>
                <div class="d-flex align-items-center flex-wrap gap-2" v-if="tblData?.dropdown?.length > 0">
                    <select class="form-control-sm form-select table-control"
                            v-for="select in tblData.dropdown" @change="select.action($event)">
                        <option v-if="select?.title" value="">{{ select.title }}</option>
                        <option :selected="param[select?.keyForSelected] == option.id"
                                v-for="option in select.data" :value="option.id">{{ option.name }}
                        </option>
                    </select>
                </div>
                <div v-if="tblData?.bulk_actions?.length > 0" class="d-flex flex-wrap gap-2">
                    <button class="btn btn-sm btn-inverse-primary btn-width" v-for="btn in tblData.bulk_actions"
                            @click="btn.action">
                        <i style="font-size: 14px" :class="btn.icon"></i>
                        {{ btn.name }}
                    </button>
                </div>
                <label class="d-flex align-items-center justify-content-center mb-0">
                    <input v-model="param.keyword" type="text" class="form-control table-control form-control-sm"
                           placeholder="Search">
                </label>
                <button class="btn btn-sm btn-inverse-primary" v-if="tblData?.searchBtn" @click="tblData.searchBtn.action">{{tblData.searchBtn.name}}</button>
            </div>
        </div>
        <div class="table-height long-scroll">
            <table class="table mb-0 table-striped table-bordered dataTable "
                   :class="tblData?.alignTop ? 'align-top' : 'align-middle'">
                <thead>
                    <tr>
                        <template v-for="headerCol in tblData['columns']">
                            <th class="checkbox-center" v-if="headerCol['type'] === 'checkbox'">
                                <input :checked="isCheckedAll()"
                                       class="form-check-input"
                                       type="checkbox"
                                       @click="toggleCheckAll($event)">
                            </th>
                            <th v-if="headerCol['type'] !== 'checkbox'" class="cursor-pointer"
                                @click="headerCol['sortable'] ? orderData(headerCol['key']) : ''"
                                :class="headerCol['sortable'] ? orderClass(headerCol['key']) : ''">
                                <div class="text-label">
                                    <div>{{ headerCol['label'] }}</div>
                                </div>
                            </th>
                        </template>
                        <th v-if="tblData.row_actions.length > 0"></th>
                    </tr>
                </thead>
                <tbody v-if="!tblData.loading && tblData.rows.length > 0">
                    <tr v-for="(dataRow, rowIndex) in tblData.rows">
                    <template v-for="dataCol in tblData['columns']">
                        <td class="checkbox-center" v-if="dataCol['type'] === 'checkbox'">
                            <input :checked="isChecked(dataRow.id)"
                                   class="form-check-input row-checkbox"
                                   type="checkbox"
                                   @click="toggleCheck($event, dataRow.id)">
                        </td>
                        <td v-if="dataCol['type'] === 'text'"
                            @click="dataCol['clickable'] !== undefined && dataCol['clickable'] === true ? clickLink(dataRow) : ''"
                            :class="dataCol['isCapital'] !== undefined && dataCol['isCapital'] === true ? 'text-capitalize' :
                             dataCol['clickable'] !== undefined && dataCol['clickable'] === true ? 'cursor-pointer' : ''">
                            <!--Photo-->
                            <span v-if="dataCol['photo'] !== undefined && dataCol['photo'] === true">
                                <img class="table-avatar" v-if="dataRow.image_path"
                                     :src="dataRow.image_path" alt="">
                            </span>
                            <!--Status-->
                            <span v-if="dataCol['isStatus'] !== undefined && dataCol['isStatus'] === true"
                                  class="badge rounded-pill text-capitalize m-0 text-white fw-normal fs-13"
                                  :class="bgColor(dataRow[dataCol['key']])">
                                {{ dataRow[dataCol['key']] }}
                            </span>
                            <!--text-->
                            <span v-else>
                                {{ dataRow[dataCol['key']] }}
                            </span>
                        </td>
                        <td v-if="dataCol['type'] === 'arrayText'">
                            <ol class="m-0 ps-3 order-list"
                                :class="{'no-list-style ps-0' : dataCol['no_list_style'] !== undefined &&  dataCol['no_list_style'] === true}">
                                <li v-for="row in dataRow[dataCol['key']]"
                                    :class="{'enable-padding':  dataCol['enable_padding'] !== undefined &&  dataCol['enable_padding'] === true}">
                                    {{ row[dataCol['text']] }}
                                    <span class="line" v-if="dataCol['border'] !== undefined &&  dataCol['border'] === true"></span>
                                </li>
                            </ol>
                        </td>
                        <!--select box-->
                        <td v-if="dataCol['type'] == 'select'">
                            <select class="ajob-select" @change="dataCol['action']($event, dataRow)" @mouseenter="updateClass($event)" @mouseleave="removeClass($event)">
                                <option :selected="s.id == dataRow[dataCol['key']]"  v-for="s in dataCol['selectArr']" :value="s.id">{{s.name}}</option>
                            </select>
                        </td>
                    </template>
                    <td v-if="tblData.row_actions.length > 0">
                        <div class="d-flex justify-content-end gap-1">
                            <template v-for="(rowAction, index) in tblData['row_actions']">
                                <button :target="rowAction['name'] === 'edit' ? '_blank' : null" class="btn btn-radius"  v-if="isBtnShow(dataRow, rowAction['name'])"
                                        v-tooltip="capitalizeFirstLetter(rowAction['name'])"
                                        :class="rowAction['color']"
                                        @click="onActionIconClick(rowAction['name'], dataRow, $event, 'actionBtn'+rowIndex+index)">
                                    <i v-if="rowAction['type'] === 'action'" :class="'actionBtn'+rowIndex+index +' '+ rowAction['label'] "></i>
                                    <i style="display: none" class="spinner-border spinner-border-sm" :class="'actionBtn'+rowIndex+index"></i>
                                </button>
                            </template>
                        </div>
                    </td>
                </tr>
                </tbody>
                <tbody v-if="!tblData.loading && tblData.rows.length > 0 && tblData?.total">
                    <tr>
                        <th class="text-end" :colspan="tblData.total.colspan">Total</th>
                        <th colspan="10">{{ tblData.total.amount }}</th>
                    </tr>
                </tbody>
                <tbody v-if="tblData.loading">
                    <tr>
                        <td colspan="100" class="loader-height">
                            <Loader></Loader>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="!tblData.loading && tblData.rows.length <= 0">
                    <tr class="text-center">
                        <td colspan="100" class="fw-bold fs-6 text-height">
                            No Data Found
                            <br>
                            {{ tblData.noDataError }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row align-items-center" v-if="tblData.paginateData != null">
            <div class="col-sm-12 col-md-5">
                <div class="d-flex align-items-center">
                    <div class="dataTables_length me-3" id="example_length">
                        <label class="table-filter fw-bold">Show
                            <select class="form-select form-select-sm ms-2 me-2" v-model="param.limit">
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            entries
                        </label>
                    </div>
                    <div class="dataTables_info" id="example3_info" role="status" aria-live="polite"
                         v-if="tblData.paginateData != null">
                        Showing {{ tblData.paginateData.from }} to {{ tblData.paginateData.to }} of
                        {{ tblData.paginateData.total }} entries
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-7">
                <div class="dataTables_paginate paging_simple_numbers float-end" id="example_paginate">
                    <Bootstrap5Pagination :data="tblData.paginateData" :limit="1" :keepLength="false"
                                          @pagination-change-page="tblData.updatePagination"></Bootstrap5Pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from './Loader'
import { Bootstrap5Pagination } from 'laravel-vue-pagination'

export default {
    name: 'Table',
    components: { Loader, Bootstrap5Pagination },
    props: ['tblData', 'param'],
    watch: {
        'param.keyword': function () {
            if (!this.tblData?.searchBtn) {
                clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.tblData.updateFilter (this.param)
                }, 800)
            }
        },
        'param.limit': function () {
            this.tblData.updateFilter(this.param)
        }
    },
    data () {
        return {
            selectedData: [],
            rowAction: null,
            date: '',
            startDate: '',
            endDate: '',
            searchTimeout: null
        }
    },
    mounted() {
        const selectedDate = this.tblData?.dateSearch?.selectedDate
        if (selectedDate) {
            this.date = selectedDate
            const parts = String(selectedDate).split(' to ')
            if (parts.length === 2) {
                this.startDate = parts[0]
                this.endDate = parts[1]
            }
        }
    },
    methods: {
        onRangeDateChange() {
            if (this.startDate && this.endDate && this.tblData?.dateSearch?.action) {
                this.tblData.dateSearch.action([new Date(this.startDate), new Date(this.endDate)])
            }
        },
        updateClass: function (e) {
            $(e.target).addClass('form-select')
        },
        removeClass: function (e) {
            $(e.target).removeClass('form-select')
        },
        clickLink: function (dataRow) {
            this.tblData.visitLink(dataRow)
        },
        isBtnShow: function (dataRow, btn) {
            if (this.tblData.row_action_disable !== undefined) {
                return this.tblData.row_action_disable({data: dataRow, btnName: btn})
            } else {
                return  true
            }
        },
        bgColor: function (status) {
            if (status === 'inactive') {
                return 'bg-danger'
            } else if (status === 'active') {
                return 'bg-primary'
            } else {
                return ''
            }
        },
        onActionIconClick: function (rowAction, rowData, event, index) {
            event.stopPropagation ()
            if (this.tblData.tableIconAction !== undefined) {
                this.tblData.tableIconAction ({ row_action: rowAction, row_data: rowData, row_index: index })
            }
        },
        orderClass: function (order_by) {
            let cls
            if (this.param.order_by == order_by && this.param.order_mode == 'DESC') {
                cls = 'ordering_desc'
            } else if (this.param.order_by == order_by && this.param.order_mode == 'ASC') {
                cls = 'ordering_asc'
            } else {
                cls = 'ordering'
            }
            return cls
        },
        orderData: function (order_name) {
            this.param.order_by = order_name
            this.param.order_mode = this.param.order_mode == 'DESC' ? 'ASC' : 'DESC'
            this.tblData.updateFilter (this.param)
        },
        isChecked: function (id) {
            return this.selectedData.indexOf (id) > -1
        },
        toggleCheck: function (event, id) {
            if (event.target.checked == true) {
                this.selectedData.push (id)
            } else {
                this.selectedData.splice (this.selectedData.indexOf (id), 1)
            }
            event.stopPropagation ()
        },
        isCheckedAll: function () {
            if (this.selectedData.length === 0) {
                return false
            }
            return this.selectedData.length === this.tblData.rows.length
        },
        toggleCheckAll: function (event) {
            if (event.target.checked === true) {
                document.querySelectorAll ('.row-checkbox').forEach (value => {
                    value.checked = true
                })
                this.tblData.rows.map (v => {
                    if (this.dataExist (v.id) === false) {
                        this.selectedData.push (v.id)
                    }
                })
            } else {
                document.querySelectorAll ('.row-checkbox').forEach (value => {
                    value.checked = false
                })
                this.selectedData = []
            }
        },
        dataExist: function (id) {
            return this.selectedData.some (value => {
                return value === id
            })
        }
    }
}
</script>

<style lang="scss">
table {
    thead {
        position: sticky;
        top: -1px;
        left: 0;
        width: 100%;
        background: #fff;
        z-index: 1;

        tr {
            th {
                &:first-child{
                    position: sticky;
                    top: -1px;
                    left: 0;
                    background: #fff;
                    z-index: 1;
                    &:before{
                        content: '';
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        right: -1px;
                        background-color: #dee2e6;
                        top: 0;
                    }
                }
            }
        }
    }
    tbody{
        tr{
            td {
                &:first-child{
                    position: sticky;
                    top: -1px;
                    left: 0;
                    background: #fff;
                    z-index: 1;
                    &:before{
                        content: '';
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        right: -1px;
                        background-color: #dee2e6;
                        top: 0;
                    }
                }
            }
        }
    }

    .order-list {
        li {
            &.enable-padding {
                padding: 10px 0;

                &:last-child {
                    padding-bottom: 4px;
                }
            }

            position: relative;

            .line {
                content: '';
                position: absolute;
                width: 100%;
                height: 1px;
                bottom: 0;
                left: 0;
                background-color: #d9d9d9;
            }

            &:last-child {
                .line {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    bottom: 0;
                    left: 0;
                    background-color: transparent;
                }
            }
        }
    }

    .checkbox-center {
        width: 0;
        text-align: center;
    }

    .ordering {
        position: relative;

        &:before {
            right: 1em;
            content: "↑";
            position: absolute;
            bottom: 0.9em;
            display: block;
            opacity: .3;
        }

        &:after {
            right: 0.5em;
            content: "↓";
            position: absolute;
            bottom: 0.9em;
            display: block;
            opacity: .3;
        }
    }

    .ordering_asc {
        position: relative;

        &:before {
            right: 1em;
            content: "↑";
            position: absolute;
            bottom: 0.9em;
            display: block;
            opacity: 1;
        }

        &:after {
            right: 0.5em;
            content: "↓";
            position: absolute;
            bottom: 0.9em;
            display: block;
            opacity: .3;
        }
    }

    .ordering_desc {
        position: relative;

        &:before {
            right: 1em;
            content: "↑";
            position: absolute;
            bottom: 0.9em;
            display: block;
            opacity: .3;
        }

        &:after {
            right: 0.5em;
            content: "↓";
            position: absolute;
            bottom: 0.9em;
            display: block;
            opacity: 1;
        }
    }
}

.loader-height {
    padding-top: 24px;
    min-height: 280px;
    max-height: 60vh;
    vertical-align: top;
}

.text-height {
    min-height: 220px;
    max-height: 50vh;
    padding-top: 28px;
    color: #64748b;
    font-weight: 500 !important;
}

.table-filter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 170px;
}

.search-filter {
    width: 250px;
}

.table-height {
    min-height: 320px;
    max-height: calc(100vh - 280px);
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;

    &.long-scroll {
        overflow-x: auto;
        white-space: nowrap;
    }

    .table {
        margin-bottom: 0;

        thead th {
            position: sticky;
            top: 0;
            z-index: 2;
        }
    }
}

.table-toolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.table-control {
    max-width: 150px;
    min-width: 130px;
    width: 130px;
    height: auto !important;
    min-height: 34px !important;
    padding: 0.25rem 2rem 0.25rem 0.75rem !important;
    font-size: 14px;
    line-height: 1.4;
}

select.table-control.form-select {
    padding-right: 2rem !important;
    background-position: right 0.6rem center;
}

.btn-option {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    width: 34px;
    padding: 0;
    height: 34px;
    border-radius: 8px;
    transition: 150ms;

    &:hover {
        background-color: #f8fafc;
        border-color: #cbd5e1;
    }
}

.table-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    object-fit: fill;
    object-position: center;
    margin-right: 15px;
}

.no-list-style {
    list-style: none;
    padding-left: 0 !important;
}
.ajob-select{
    width: 100%;
    display: block;
    padding: 0.375rem 2.25rem 0.375rem 0.75rem;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: transparent;
    border: 1px solid transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.form-select{
    border: 1px solid #ced4da!important;
    background-color: #ffffff!important;
}
</style>
